var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("set-default-printer")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      disabled: _vm.printers.length == 0,
                      fancy: "",
                      label: _vm.$ct("default-printer"),
                      items: _vm.printerItems,
                    },
                    model: {
                      value: _vm.defaultPrinterSettings.deviceId,
                      callback: function ($$v) {
                        _vm.$set(_vm.defaultPrinterSettings, "deviceId", $$v)
                      },
                      expression: "defaultPrinterSettings.deviceId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { fancy: "", label: _vm.$ct("print-in-landscape") },
                    model: {
                      value: _vm.defaultPrinterSettings.printInLandscape,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.defaultPrinterSettings,
                          "printInLandscape",
                          $$v
                        )
                      },
                      expression: "defaultPrinterSettings.printInLandscape",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct(
                        "use-multiple-print-jobs-instead-of-copies"
                      ),
                    },
                    model: {
                      value:
                        _vm.defaultPrinterSettings
                          .useMultiplePrintJobsInsteadOfCoppies,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.defaultPrinterSettings,
                          "useMultiplePrintJobsInsteadOfCoppies",
                          $$v
                        )
                      },
                      expression:
                        "defaultPrinterSettings.useMultiplePrintJobsInsteadOfCoppies",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }